import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-12 md:py-16 bg-transparent" data-id="element-162">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-163">
        <div className="mb-10" data-id="element-164">
          <span className="inline-block px-6 py-2.5 mb-5 rounded-full border border-white/40 bg-[#7d8a6e] text-white font-semibold tracking-[0.18em] uppercase text-xs" data-id="element-165">
            LA SOLUCIÓN QUE ESPERABAS — UN SISTEMA TODO EN UNO
          </span>
          <h2 className="font-heading md:text-5xl font-bold text-[#2f3a2c] mb-6 max-w-3xl mx-auto text-[28px] leading-tight" data-id="element-166">
            El único plan que tu hijo necesita para volver a clases{' '}
            <span className="text-[#6f7a64] italic" data-id="element-167">más fuerte que nunca</span>
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-168">
          <img src="https://cdn.magicpatterns.com/uploads/eFH2RTJzZgdAZZGictGjis/Texto_del_parrafo_%289%29.webp" alt="Expedición 5to Grado — Sistema de Entrenamiento Académico" width={672} height={672} loading="lazy" decoding="async" sizes="(max-width: 768px) 100vw, 672px" className="w-full h-auto max-w-2xl mx-auto rounded-2xl shadow-xl shadow-navy/5 border border-slate-100" data-id="element-169" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white/60 border border-amber-100 text-[#2f3a2c] rounded-3xl p-8 md:p-10 shadow-sm" data-id="element-170">
          <p className="md:text-xl font-medium text-slate-700 text-[16px]" data-id="element-171">
            <span className="text-[#6f7a64] font-bold italic" data-id="element-172">
              EXPEDICIÓN 5TO GRADO
            </span>{' '}
            es mucho más que un cuadernillo de actividades. Es un sistema de
            entrenamiento académico inmersivo que entrega 14 misiones diarias
            estructuradas pedagógicamente para reforzar las cuatro áreas clave
            del segundo cuatrimestre de primaria.
          </p>
        </motion.div>
      </div>
    </section>;
}